import React, {MouseEvent, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {pageAPI} from "../../../api/page";
import {isEmail} from "../../../utils/convert";
import {setOptionsAction} from "../../../store/reducers/commonSlice";

const validations = {
    email: isEmail
}

const TracingOptions = () => {
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(state => state.auth.authUser)
    const {data: emails} = pageAPI.useGetAllEmailsQuery()
    const options = useAppSelector(state => state.common.options)

    const changeOption = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = e.currentTarget.name
        const fieldValue = e.currentTarget.value

        dispatch(setOptionsAction({
            [fieldName]: fieldValue
        }))
    }

    const onBlurValidate = (validationType: keyof typeof validations) => {
        return (e: React.FocusEvent<HTMLInputElement>) => {
            const fieldValue = e.currentTarget.value
            if (fieldValue === '') {
                e.target.classList.remove('bg-red-200')
                return;
            }

            const validate = validations[validationType]
            if (validate && !validate(fieldValue)){
                e.target.classList.add('bg-red-200')
            } else {
                e.target.classList.remove('bg-red-200')
            }
        }
    }

    if (!authUser) return <></>

    return (
        <div>
            {authUser?.isAdmin && <div className="flex items-center mb-2">
                <span className="mr-3 select-none">Email: </span>
                <datalist id="email-list">
                    {Array.isArray(emails) && emails.map((email: string, i: number) => <option key={i} value={email} />)}
                </datalist>
                <input
                    type="email"
                    list="email-list"
                    className="py-1 px-4 border-[1px] outline-none rounded-sm"
                    onChange={changeOption}
                    onBlur={onBlurValidate('email')}
                    value={options.tracingEmail}
                    name="tracingEmail"
                />
            </div>}
        </div>
    );
};

export default TracingOptions;